// Constants for consistent pivot table labeling

// Null handling constants
export const NULL_TOKEN = '∅';
export const NULL_LABEL = '(null)';

export const PIVOT_LABELS = {
  // Dimension labels for display (Greek)

  isActiveLabel: 'Ενεργή',
  region: 'Περιοχή',
  regionName: 'Περιοχή',
  routeLineId: 'Διαδρομή',
  collectionOrderCode: 'Κωδικός Εντολής',
  month: 'Μήνας',
  dateCollected: 'Ημερομηνία Συλλογής',
  collectorName: 'Όνομα Συλλέκτη',
  collectionPointId: 'Κωδικός Σημείου Συλλογής',
  collectionPointName: 'Όνομα Σημείου Συλλογής',
  vehiclePlate: 'Πινακίδα',
  vehicleBrand: 'Μάρκα',
  driverName: 'Οδηγός',

  materialName: 'Όνομα Υλικού',

  // Standard labels (Greek)
  NULL_VALUE: NULL_LABEL,
  TOTAL_VALUE: 'Σύνολο',
  NULL_LABEL: NULL_LABEL,
  TOTAL_LABEL: 'Σύνολο',
  EMPTY_DROP_ZONE: 'Αποθέστε πεδία εδώ',
  LOADING: 'Φόρτωση...',
  NO_DATA: 'Δεν υπάρχουν διαθέσιμα δεδομένα',
  QUERY_SKIPPED: 'Το ερώτημα παραλείφθηκε (χωρίς διαστάσεις γραμμών ή στηλών)',
} as const;

// Helper function for comparing values with proper type handling
export function compareValues(
  a: string | number | null,
  b: string | number | null,
  valueType: 'string' | 'number' | 'date',
): number {
  // Handle nulls - always sort to the end
  if (a === null && b === null) return 0;
  if (a === null) return 1;
  if (b === null) return -1;

  switch (valueType) {
    case 'number':
      const numA = Number(a);
      const numB = Number(b);
      if (isNaN(numA) && isNaN(numB)) return 0;
      if (isNaN(numA)) return 1;
      if (isNaN(numB)) return -1;
      return numA - numB;

    case 'date':
      const dateA = new Date(String(a));
      const dateB = new Date(String(b));
      if (isNaN(dateA.getTime()) && isNaN(dateB.getTime())) return 0;
      if (isNaN(dateA.getTime())) return 1;
      if (isNaN(dateB.getTime())) return -1;
      return dateA.getTime() - dateB.getTime();

    case 'string':
    default:
      return String(a).localeCompare(String(b));
  }
}

// Helper function to format display values
export function formatDisplayValue(
  value: string | number | null,
  valueType: 'string' | 'number' | 'date',
): string {
  if (value === null || value === undefined) {
    return NULL_LABEL;
  }

  switch (valueType) {
    case 'date':
      // Try to format as date, fall back to string
      const date = new Date(String(value));
      if (!isNaN(date.getTime())) {
        return date.toLocaleDateString();
      }
      return String(value);

    case 'number':
      const num = Number(value);
      if (!isNaN(num)) {
        return num.toLocaleString();
      }
      return String(value);

    case 'string':
    default:
      return String(value);
  }
}
